import { Link } from 'react-router-dom';
import { GameShell } from './EnvLayout';
import { useAdminMode } from './useAdminMode';
import AdminCarbon from './AdminCarbon';
import FootprintGame from './FootprintGame';
import { ui } from './envUi';

/** The calculator, plus admin sign-in and an editor for its categories and objects. */
export default function CalculatorGame({ title }: { title: string }) {
  const { editing, actions, loginModal } = useAdminMode('Calculator');

  return (
    <GameShell title={title} right={actions}>
      {editing ? (
        <div className="mx-auto max-w-3xl px-4 py-6 md:py-10">
          <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <span className="rounded-full bg-yellow-400 px-3 py-1 text-xs font-bold uppercase tracking-wide text-black">Admin mode</span>
              <span className={ui.muted}>Changes show in the calculator straight away.</span>
            </div>
            <Link to="/environmental/admin" className={ui.btnGhost}>All admin settings</Link>
          </div>
          <AdminCarbon />
        </div>
      ) : (
        <FootprintGame />
      )}
      {loginModal}
    </GameShell>
  );
}
